import { InputAdornment, TextField } from '@mui/material';
import OutlinedInput from '@mui/material/OutlinedInput';
import ClearIcon from '@mui/icons-material/Clear';
import React,{useState,useEffect} from 'react'


const Pignone = (props) => {

    const {pignone,setPignone, maxWidth = '50px'} = props

    return (<TextField InputLabelProps={{ shrink: true }}  size="small" value={pignone}  onChange={(e) => {setPignone(e.target.value)}} style={{maxWidth: maxWidth, marginRight: '5px', marginBottom: '5px'}}/>)

}

export default Pignone

/* 

endAdornment={
   <InputAdornment position="end">
     <IconButton
       aria-label="toggle password visibility"
       onClick={() => {}}
       onMouseDown={() => {}}
       edge="end"
     >
       <ClearIcon />
     </IconButton>
   </InputAdornment>
 }


*/